import React, { FC, useMemo, useState } from 'react';
import { useTheme } from 'styled-components';
import { PageContainer, Title, faFileLines } from '@/ui/components';
import { useTranslate } from '@/translations';
import { Button, Card } from 'antd';
import { useSearchParams } from 'react-router-dom';
import { useAppCustomers } from '@/hooks';
import { DocumentManagementDataGrid } from './components/DocumentManagementDataGrid/DocumentManagementDataGrid';
import { DocumentTypesModal } from './components/DocumentTypesModal';
import {
  getInitialValuesFromSearchParams,
  UploadDocumentModal,
} from './components/UploadDocumentModal';

export const DocumentManagement: FC = () => {
  const { t } = useTranslate();
  const { accent } = useTheme();
  const [searchParams] = useSearchParams();
  const { hasAdminAccess } = useAppCustomers();
  const [showDocumentType, setShowDocumentType] = useState(false);
  const [showUploadDocument, setShowUploadDocument] = useState(false);

  const uploadDocumentInitialValues = useMemo(
    () => getInitialValuesFromSearchParams(searchParams),
    [searchParams],
  );

  return (
    <PageContainer>
      <Title
        title={t('documentManagement')}
        icon={faFileLines}
        color={accent}
      />

      {hasAdminAccess ? (
        <div className="d-flex align-items-center gap-3">
          <Button
            type="primary"
            size="large"
            onClick={() => setShowDocumentType(true)}
          >
            {t('documentTypes')}
          </Button>
          <Button
            type="primary"
            size="large"
            onClick={() => setShowUploadDocument(true)}
          >
            {t('uploadDocument')}
          </Button>
        </div>
      ) : null}
      <Card>
        <DocumentManagementDataGrid />
      </Card>
      <DocumentTypesModal
        isOpen={showDocumentType}
        closeModal={() => setShowDocumentType(false)}
      />
      <UploadDocumentModal
        isOpen={showUploadDocument}
        closeModal={() => setShowUploadDocument(false)}
        initialValues={uploadDocumentInitialValues}
      />
    </PageContainer>
  );
};
